import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TrackContainer from "./TrackContainer";
import { selectRole } from "./infoSlice";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { useMemo } from "react";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";

const QuantityTrack = ({ history }) => {
  const { t } = useTranslation();
  const role = useSelector(selectRole);
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const quantityOptions = useMemo(() => {
    switch (role) {
      case "Partner":
      case "Kid":
      case "Friend":
      case "Sibling":
      case "Grandparent":
      default:
        return [
          {
            id: 0,
            imgPath: ('../assets/how_many/one_two.png'),
            name: t("one_two"),
            value: "1_2"
          },
          {
            id: 1,
            imgPath: ('../assets/how_many/three_five.png'),
            name: t("three_five"),
            value: "3_5"
          },
          {
            id: 2,
            imgPath: ('../assets/how_many/six_ten.png'),
            name: t("six_ten"),
            value: "6-10"
          },
          {
            id: 3,
            imgPath: ('../assets/how_many/ten_plus.png'),
            name: t("ten_plus"),
            value: "10"
          },
        ];
    }
  }, [t, role]);

  const onSingleClick = (quantity) => {
    dispatch(setEventData({ id: "Quantity", data: quantity }));
    sendAnalyticsEvents(EVENTS.onboardingQuantitySubmitted, {
      ...eventsData,
      Quantity: quantity,
    });
    history.push(`/choose-feature`);
  };

  return (
    <TrackContainer
      pageEvent={"onboardingQuantityShown"}
      title={t("question7_title")}
      options={quantityOptions}
      onSingleClick={onSingleClick}
      nextPage={'choose-feature'}
    />
  );
}

export default QuantityTrack;